import { RouteFallback } from './loaders/Loaders';

export default function BootFallback() {
  return <RouteFallback />;
}
